import { isEmptyValue } from "../../../utils/StringUtil";

export function camposLoginValidos(formData) {
  for (const key in formData) {
    if (isEmptyValue(formData[key])) {
      return false;
    }
  }

  return true;
}